import React from "react";
import injectSheet from "react-jss";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";

import JanHartmannPhoto from "../assets/janhartmann-photo.jpg";
import { Heading, Icon } from "../components/shared";

const IndexPage = ({ classes }) => (
  <div>
    <Helmet title="Jan Hartmann" />
    <Heading level={1} text="Hi, I'm Jan Hartmann" />
    <div className={classes.root}>
      <div className={classes.content}>
        <p className={classes.introduction}>
          <strong>
            Danish software engineer with the unique ability of creating both
            outstanding user-interfaces and sharp, tested server-side function.
          </strong>
        </p>
        <p>
          Possessing a wide set of skills, I enjoy building awesome, secure,
          highly effective and performing web- and mobile applications.
        </p>
        <p>
          I am obsessed with the Internet and how it looks, feels and functions
          and because of this, I{"'"}ve been ever evolving and perfecting my
          skills in all layers of modern web– and mobile development.
        </p>
        <p>Contact me though one of the sites below:</p>
        <ul className={classes.links}>
          <li>
            <a href="https://www.linkedin.com/in/janhartmanndk/">
              <Icon iconName="linkedin" /> LinkedIn
            </a>
          </li>
          <li>
            <a href="https://github.com/janhartmann">
              <Icon iconName="github" /> GitHub
            </a>
          </li>
          <li>
            <a href="https://stackoverflow.com/users/99395/janhartmann">
              <Icon iconName="code" /> Stack Overflow
            </a>
          </li>
        </ul>
      </div>
      <div className={classes.photo}>
        <img
          src={JanHartmannPhoto}
          alt="Photo of Jan Hartmann"
          className={classes.photoImage}
        />
      </div>
    </div>
  </div>
);

IndexPage.propTypes = {
  classes: PropTypes.object.isRequired
};

const styles = theme => ({
  photo: {
    marginTop: theme.layout.gutter
  },
  introduction: {
    fontSize: 19,
    color: theme.colors.gray[1]
  },
  links: {
    listStyle: "none",
    padding: 0,
    margin: 0,
    "& li": {
      verticalAlign: "middle"
    },
    "& li + li": {
      marginTop: theme.layout.gutter / 2
    },
    "& a": {
      color: theme.colors.primary[1],
      "&:hover": {
        color: theme.colors.primary[3]
      }
    },
    "& svg": {
      marginRight: 5
    }
  },
  photoImage: {
    borderRadius: theme.layout.borderRadius,
    maxWidth: "100%",
    margin: [0, "auto"]
  },
  "@media (min-width: 1024px)": {
    root: {
      display: "flex"
    },
    content: {
      flex: 1
    },
    photo: {
      flex: 1,
      marginTop: 0,
      marginLeft: theme.layout.gutter * 2
    },
    links: {
      listStyle: "none",
      padding: 0,
      margin: 0,
      "& li": {
        display: "inline-block"
      },
      "& li + li": {
        marginTop: 0,
        marginLeft: theme.layout.gutter / 2
      }
    }
  }
});

export default injectSheet(styles)(IndexPage);



// WEBPACK FOOTER //
// ./src/pages/index.js